module.exports = __webpack_public_path__ + "static/media/icon_warning.a000e58b.svg";